@import 'styles/mixins';
@import 'styles/variables';

.UserProfileCard {
  .profileImageInner {
    transition: all 0.2s ease-in-out;
    width: 100%;
    height: 100%;
    font-size: 49px;

    &.initials {
      min-height: 100%;
      min-width: 100%;
    }
  }

  .enlarged {
    .profileImageInner {
      font-size: 52px;
      transform: scale(1.05);
      &.initials {
        transform: none;
        min-height: 105%;
        min-width: 105%;
      }
    }
  }

  .contentWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .info {
      margin: 0 0 13px 0;

      .name {
        @include ui-md-text;
        text-align: center;
        margin: 0 0 3px 0;
        padding: 0;

        .isMe {
          color: $gray-40;
        }
      }

      .role,
      .status {
        color: $gray-60;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        margin: 0 0 4px 0;
        word-break: break-all;
        text-align: center;
        padding: 0;
      }
    }

    .location {
      color: $gray-40;
      @include ui-xs-text;
      margin: 0;
      padding: 0;
    }
  }
}
